import { render, staticRenderFns } from "./ResultTermList.vue?vue&type=template&id=6684c18d"
import script from "./ResultTermList.vue?vue&type=script&lang=js"
export * from "./ResultTermList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports